/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tv } from 'tailwind-variants';
import { useComponentProps } from '@sitecore-content-sdk/nextjs';
import { useSitecoreContext } from 'lib/hooks/useSitecoreContext';
import PopularArticlesWidget from 'widgets/PopularArticles';
import PlainTextWrapper from 'helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';
import { getTestProps } from 'lib/testing/utils';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
import useIsEditing from 'lib/hooks/useIsEditing';
const PopularArticles = (props)=>{
    const isEditing = useIsEditing();
    const id = props?.params?.RenderingIdentifier;
    const articleLimit = props?.fields?.numberOfArticles?.value ? props?.fields?.numberOfArticles.value : 3;
    const ctxProps = useComponentProps(props?.rendering?.uid);
    const staticProps = props?.staticProps ?? ctxProps?.staticProps;
    const context = useSitecoreContext();
    const searchSources = context?.sitecoreContext?.siteSettings?.globalSearchSourceId?.value;
    const sources = searchSources ? searchSources.split('|').map((s)=>s.trim()).filter((s)=>s) : [];
    const rfkid = context?.sitecoreContext?.siteSettings?.globalRecommendationWidgetId?.value;
    const { base, titleStyle } = TAILWIND_VARIANTS();
    return /*#__PURE__*/ _jsxs("section", {
        className: base(),
        id: id ? id : undefined,
        "data-component": "authorable/shared/page-specific/populararticles",
        ...editingHydrationProps(isEditing),
        ...getTestProps(`component-popular-articles-${props?.rendering?.uid}`),
        children: [
            /*#__PURE__*/ _jsx(PlainTextWrapper, {
                className: titleStyle(),
                field: props?.fields?.title,
                tag: "h2",
                ...getTestProps(`title`)
            }),
            /*#__PURE__*/ _jsx(PopularArticlesWidget, {
                rfkId: rfkid || '',
                articleLimit: articleLimit,
                searchSources: sources,
                staticProps: staticProps,
                ...getTestProps(`popular-articles-widget`)
            })
        ]
    });
};
export default PopularArticles;
const TAILWIND_VARIANTS = tv({
    slots: {
        base: [
            'flex',
            'flex-col',
            'gap-spacing-spacing-24',
            'text-component-feature-title'
        ],
        titleStyle: [
            'text-component-feature-title',
            'font-typography-font-family-header',
            'text-typography-font-size-medium',
            'leading-typography-line-height-medium',
            'font-bold'
        ]
    }
});
